import {
  Calendar as CalendarIcon,
  Flame,
  Inbox,
  Repeat,
  Settings as SettingsIcon,
  Sun,
} from 'lucide-react';
import type { ComponentType, SVGProps } from 'react';

export interface NavItem {
  to: string;
  label: string;
  icon: ComponentType<SVGProps<SVGSVGElement>>;
  badge?: number; // optional unread/count badge — wired in later phases
  section: 'primary' | 'workspace';
  mobile: boolean;
}

export const NAV_ITEMS: NavItem[] = [
  { to: '/app', label: 'Today', icon: Sun, section: 'primary', mobile: true },
  { to: '/app/inbox', label: 'Inbox', icon: Inbox, section: 'primary', mobile: true },
  { to: '/app/routines', label: 'Routines', icon: Repeat, section: 'primary', mobile: true },
  { to: '/app/habits', label: 'Habits', icon: Flame, section: 'primary', mobile: true },
  {
    to: '/app/calendar',
    label: 'Calendar',
    icon: CalendarIcon,
    section: 'workspace',
    mobile: false,
  },
  {
    to: '/app/settings',
    label: 'Settings',
    icon: SettingsIcon,
    section: 'workspace',
    mobile: true,
  },
];

/** Subset shown in the mobile bottom tab bar — sized for 5 max. */
export const MOBILE_TAB_ITEMS: NavItem[] = NAV_ITEMS.filter((i) => i.mobile);
